var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leave-lists" },
    [
      _vm.commentListTitle
        ? _c("div", { staticClass: "leave-lists-title" }, [
            _c("div", { staticClass: "lists-title-head" }, [
              _vm._v(
                _vm._s(
                  _vm.commentListTitle + "(" + _vm.commentsTotalCount + ")"
                )
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.commentsList && _vm.commentsList.length > 0
        ? _c(
            "div",
            { staticClass: "leave-recove-main" },
            [
              _vm._l(_vm.commentsList, function(item, index) {
                return !item.IsDel || (item.ReplyList && item.ReplyList.length)
                  ? _c(
                      "div",
                      {
                        key: index,
                        ref: item.Id,
                        refInFor: true,
                        staticClass: "leave-item",
                        class: {
                          "leave-item-no-padding":
                            !_vm.commentListTitle ||
                            index == _vm.commentsList.length - 1,
                          "comment-mark": item.Id == _vm.commentId
                        }
                      },
                      [
                        _c("div", { staticClass: "leave-head" }, [
                          _c("img", {
                            attrs: {
                              src:
                                item.HeadImage || "/static/images/default.png"
                            },
                            on: { error: _vm.$imgErr }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "leave-container",
                            class: { itemBorder: !_vm.commentListTitle }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "leave-title",
                                on: {
                                  click: function($event) {
                                    return _vm.answerPublish(item, index)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "title-head" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-head-name" },
                                    [_vm._v(_vm._s(item.Name))]
                                  ),
                                  _vm._v(" "),
                                  item.Identity == 1
                                    ? _c(
                                        "div",
                                        { staticClass: "knowledge-expert" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src:
                                                "/static/images/knowledge_expert.png",
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.IsAdmin && !item.IsDel
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "title-head-delete",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.deleteBtnClick(
                                                item,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "title-time" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$calcTime(item.CreateDate + "000")
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "leave-content" }, [
                              !item.IsDel
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "leave-content-main",
                                      on: {
                                        click: function($event) {
                                          return _vm.answerPublish(item, index)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "content-main-word" },
                                        [
                                          item.ReplyADAccount !=
                                          item.ReplyToADAccount
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "recovery-answer"
                                                },
                                                [_vm._v("回复")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.ReplyADAccount !=
                                          item.ReplyToADAccount
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "recovery-first-name"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(item.ReplyTo) + ":"
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(item.Comment) +
                                              "\n                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.AttachList &&
                                      item.AttachList.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "content-main-img" },
                                            _vm._l(item.AttachList, function(
                                              imgs,
                                              i
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: i,
                                                  staticClass: "main-item-img",
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.showImg(
                                                        i,
                                                        item.AttachList
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "source-img",
                                                    attrs: {
                                                      src:
                                                        imgs ||
                                                        "/static/images/default.png"
                                                    },
                                                    on: { error: _vm.$imgErr }
                                                  })
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "leave-content-delete-tip" },
                                    [
                                      _c("span", { staticClass: "left-cane" }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "delete-tip" },
                                        [_vm._v("评论已删除")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "right-cane" })
                                    ]
                                  )
                            ]),
                            _vm._v(" "),
                            !_vm.recoveryTitle &&
                            item.ReplyList &&
                            item.ReplyList.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "leave-answer",
                                    on: {
                                      click: function($event) {
                                        return _vm.checkMoreRecovery(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm._l(item.ReplyList, function(
                                      subRecovery,
                                      sub
                                    ) {
                                      return sub < 3
                                        ? _c(
                                            "div",
                                            {
                                              key: sub,
                                              staticClass:
                                                "leave-answer-recovery"
                                            },
                                            [
                                              subRecovery.ReplyToADAccount !==
                                                item.ADAccount ||
                                              subRecovery.ReplyADAccount !==
                                                subRecovery.ReplyToADAccount
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "comment-content"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            subRecovery.ReplyBy
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" 回复 "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            subRecovery.ReplyTo
                                                          ) + "："
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        _vm._s(
                                                          subRecovery.ReplyMessage
                                                        ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "comment-content"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            subRecovery.ReplyBy
                                                          ) + "："
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        _vm._s(
                                                          subRecovery.ReplyMessage
                                                        ) +
                                                          "\n                        "
                                                      )
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              subRecovery.AttachList &&
                                              subRecovery.AttachList.length
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "recovery-img"
                                                    },
                                                    _vm._l(
                                                      subRecovery.AttachList,
                                                      function(
                                                        subImgs,
                                                        subImgIndex
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: subImgIndex,
                                                            staticClass:
                                                              "recovery-img-answer"
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "source-img",
                                                              attrs: {
                                                                src:
                                                                  subImgs ||
                                                                  "/static/images/default.png"
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.$imgErr
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                    _vm._v(" "),
                                    item.ReplyList.length > 3
                                      ? _c(
                                          "div",
                                          { staticClass: "more-recovery" },
                                          [
                                            _vm._v(
                                              "- 查看全部回复 " +
                                                _vm._s(item.ReplyList.length) +
                                                " 条"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.commentListTitle &&
              _vm.commentsList &&
              _vm.commentsList.length < _vm.commentsForPageCount &&
              _vm.commentsForPageCount > _vm.pageSize &&
              _vm.checkMoreComment
                ? _c("div", { staticClass: "more-leave" }, [
                    _c(
                      "div",
                      {
                        staticClass: "more-leave-btn",
                        on: {
                          click: function($event) {
                            return _vm.$emit("checkMoreCommentClick")
                          }
                        }
                      },
                      [_vm._v("查看更多评论")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("loading-more")
            ],
            2
          )
        : _c("div", { staticClass: "no-leave" }, [
            _c("img", {
              attrs: { src: require("../../static/images/noLeave2.png") }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "no-leave-text" }, [
              _vm._v("还没有人留言哦")
            ])
          ]),
      _vm._v(" "),
      _vm.callCommentInput
        ? _c("leave-question", {
            attrs: { commentInfo: _vm.commentInfo, extraInfo: _vm.extraInfo },
            on: { successPush: _vm.successPush }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.callQuitWarning
        ? _c("quit-message", {
            attrs: {
              mask: true,
              messageTitle: _vm.messageTitle,
              messageText: _vm.messageText,
              queryBtn: _vm.queryBtn
            },
            on: {
              closeQuitWarning: _vm.closeQuitWarning,
              eventContinue: _vm.eventContinue
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceList && _vm.sourceList.length
        ? _c("photo-package", {
            ref: "sourcePreview",
            attrs: {
              list: _vm.sourceList,
              options: _vm.options,
              selector: ".source-img"
            },
            on: { "on-close": _vm.closeHandler }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("water-mark", { ref: "watermark2" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-248a0595", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-248a0595","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/leaveList.vue
// module id = null
// module chunks = 